module.exports = __webpack_public_path__ + "img/09.bcb46f9f.jpg";